import { OM_URL } from "..";
import {
  CustomerOrderCustomerInfo,
  CustomerOrderProductInfo,
} from "../../../model/OrderManagement/CustomerOrder";
import { CustomerOrderRefundInfo } from "../../../model/OrderManagement/CustomerOrder/Refund";
import { CustomerOrderReservationInfo } from "../../../model/OrderManagement/CustomerOrder/Reservation";
import { CustomerOrderThisInfo } from "../../../model/OrderManagement/CustomerOrder/This";
import { ListResponse } from "../../../model/common/ListResponse";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";

const OM_ORDER_URL = `${OM_URL}/orders`;

/**
 * 주문 현황 상세 - 고객정보 불러오기
 * @param orderNo
 * @returns
 */
export const getOMCustomerInfo = async (
  orderNo: string
): Promise<CustomerOrderCustomerInfo> => {
  const url = `${OM_ORDER_URL}/${orderNo}/customer-info`;

  const response = await httpRequest({ method: axiosUtils.GET, url });

  return response?.data.row;
};

/**
 * 주문 현황 상세 - 상품정보 불러오기
 * @param orderNo
 * @returns
 */
export const getOMProductInfo = async (
  orderNo: string
): Promise<ListResponse<CustomerOrderProductInfo>> => {
  const url = `${OM_ORDER_URL}/${orderNo}/product-info`;

  const response = await httpRequest({ method: axiosUtils.GET, url });

  return response?.data;
};

/**
 * 주문 현황 상세 - 예약정보 불러오기
 * @param orderNo
 * @returns
 */
export const getOMReservationInfo = async (
  orderNo: string
): Promise<ListResponse<CustomerOrderReservationInfo>> => {
  const url = `${OM_ORDER_URL}/${orderNo}/reservation-info`;

  const response = await httpRequest({ method: axiosUtils.GET, url });

  return response?.data;
};

/**
 * 주문 현황 상세 - 환불정보 불러오기
 * @param orderNo
 * @returns
 */
export const getOMRefundInfo = async (
  orderNo: string
): Promise<ListResponse<CustomerOrderRefundInfo>> => {
  const url = `${OM_ORDER_URL}/${orderNo}/refund-info`;

  const response = await httpRequest({ method: axiosUtils.GET, url });

  return response?.data;
};

/**
 * 주문 현황 상세 - 주문정보 불러오기
 * @param orderNo
 * @returns
 */
export const getOMThisInfo = async (
  orderNo: string
): Promise<CustomerOrderThisInfo> => {
  const url = `${OM_ORDER_URL}/${orderNo}/this`;

  const response = await httpRequest({ method: axiosUtils.GET, url });
  return response?.data.row;
};
